<template>
  <div>
    <v-row align="center" class="pa-4">
      <v-card-title class="pb-4 pr-8">Журнал предоставление гостевого доступа</v-card-title>
      <v-spacer></v-spacer>
    </v-row>
    <v-col cols="12" sm="7" md="8" lg="7" class="py-0 mb-6">
      <v-row class="mb-2" align="center" flex-wrap="wrap">
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="230px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeFilter"
              label="Промежуток времени"
              outlined
              dense
              hide-details
              style="max-width: 340px;"
              class="input input-search mr-2 pl-3"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
              readonly
            />
          </template>
          <v-date-picker v-model="dateFilter" range :max="today">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Назад
            </v-btn>
            <v-btn text color="primary" :disabled="!dateFilter[0]" @click="dateFilter = []">
              Сбросить
            </v-btn>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-checkbox
          v-model="includeDeleted"
          label="Включая удалённые"
          hide-details
          class="mt-0 mr-2"
          style="max-width: 180px;"
        />
        <v-btn color="primary" class="text-none ml-4" @click="loadHistory">
          Поиск
        </v-btn>
      </v-row>
    </v-col>
    <v-data-table
      class="table"
      :headers="headers"
      :items="items"
      :loading="loading"
      :server-items-length="pagination.total"
      :options.sync="tableOptions"
      :footer-props="{
        'items-per-page-options': [10, 15, 20, 50],
        showFirstLastPage: true,
      }"
      @update:options="onOptionsUpdate"
    >
      <template v-slot:item.telephone="{ item }">
        {{ formatPhoneNumber(item.telephone) }}
      </template>
      <template v-slot:item.barrier="{ item }">
        <template v-if="item.barrier">
          <div>{{ item.barrier.name || '—' }}</div>
          <router-link v-if="item.barrier_id" :to="`/barrier/${item.barrier_id}`" class="routerLink text-caption">
            {{ item.barrier.address || '—' }}
          </router-link>
          <span v-else class="text-caption">—</span>
        </template>
        <span v-else>—</span>
      </template>
      <template v-slot:item.date_begin="{ item }">
        {{ formatDate(item.date_begin) }}
      </template>
      <template v-slot:item.date_end="{ item }">
        {{ formatDate(item.date_end) }}
      </template>
      <template v-slot:item.deleted_at="{ item }">
        <span v-if="item.deleted_at" class="error--text">
          {{ formatDateTime(item.deleted_at) }}
        </span>
        <span v-else>—</span>
      </template>
      <template v-slot:item.created_at="{ item }">
        {{ formatDateTime(item.created_at) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';

export default {
  name: 'GuestAccessHistoryClient',
  mixins: [ruDateFormatMixin],
  data () {
    return {
      loading: false,
      menuFilterDate: false,
      dateFilter: [],
      today: new Date().toISOString().split('T')[0],
      includeDeleted: true,
      items: [],
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0,
      },
      tableOptions: {
        page: 1,
        itemsPerPage: 15,
      },
      headers: [
        { text: 'Гос номер', value: 'car_number', sortable: false, width: '10%' },
        { text: 'Телефон', value: 'telephone', sortable: false, width: '12%' },
        { text: 'Шлагбаум', value: 'barrier', sortable: false, width: '20%' },
        { text: 'Дата начала', value: 'date_begin', sortable: false, width: '10%' },
        { text: 'Дата окончания', value: 'date_end', sortable: false, width: '10%' },
        { text: 'Комментарий', value: 'comment', sortable: false, width: '14%' },
        { text: 'Удалено', value: 'deleted_at', sortable: false, width: '12%' },
        { text: 'Создано', value: 'created_at', sortable: false, width: '12%' },
      ],
    };
  },
  computed: {
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1], true)}`;
      }
      return `${formattedStartDate}${formattedEndDate}`;
    },
  },
  created () {
    this.loadHistory();
  },
  methods: {
    ...mapActions({
      getGuestAccessHistory: 'Client/getGuestAccessHistory',
    }),
    formatDate (value) {
      if (!value) return '—';
      return this.ruDateFormat(value, true);
    },
    formatDateTime (value) {
      if (!value) return '—';
      return this.ruDateFormat(value, false, true);
    },
    formatPhoneNumber (phone) {
      if (!phone) return '—';
      const digits = String(phone).replace(/\D/g, '');
      if (digits.length >= 11) {
        return `+${digits.slice(0, 1)} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
      }
      return phone;
    },
    onOptionsUpdate (opts) {
      const pageChanged = opts.page !== undefined && opts.page !== this.tableOptions.page;
      const perPageChanged = opts.itemsPerPage !== undefined && opts.itemsPerPage !== this.tableOptions.itemsPerPage;
      if (opts.page !== undefined) this.tableOptions.page = opts.page;
      if (opts.itemsPerPage !== undefined) {
        this.tableOptions.itemsPerPage = opts.itemsPerPage;
        this.pagination.per_page = opts.itemsPerPage;
      }
      if (pageChanged || perPageChanged) this.loadHistory();
    },
    async loadHistory () {
      this.loading = true;
      const clientId = this.$route.params.id;
      const params = {
        client_id: clientId ? Number(clientId) : undefined,
        date_from: this.dateFilter[0] || undefined,
        date_to: this.dateFilter[1] || undefined,
        include_deleted: this.includeDeleted,
        per_page: this.tableOptions.itemsPerPage || 15,
        page: this.tableOptions.page || 1,
      };
      try {
        const response = await this.getGuestAccessHistory(params);
        this.items = response.data || [];
        const pag = response.pagination || {};
        this.pagination = {
          current_page: pag.current_page ?? 1,
          last_page: pag.last_page ?? 1,
          per_page: pag.per_page ?? 15,
          total: pag.total ?? 0,
        };
      } catch (e) {
        console.error(e);
        this.$flash_warning('Не удалось загрузить журнал гостевого доступа');
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.routerLink {
  text-decoration: none;
  color: inherit;
}
.routerLink:hover {
  text-decoration: underline;
}
</style>
